import React from 'react';
import { useTranslation } from 'react-i18next';
import apartmentRoomImage from '../assets/Villa/dr.png'; // Import the image

const ApartmentRooms = () => {
    const { t } = useTranslation();

    // Handler to open WhatsApp with pre-filled message
    const handleBookNow = () => {
        const phoneNumber = '+94775340670';
        const message = encodeURIComponent(t('apartmentsSection.bookNowMessage'));
        const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;
        window.open(whatsappUrl, '_blank');
    };

    return (
        <>
            {/* Small Screen Section (sm, <768px) */}
            <section className="block md:hidden container mx-auto my-8 px-4">
                <div className="text-center mb-8">
                    <p className="text-yellow-500 text-base sm:text-lg mb-4">
                        {t('apartmentsSection.subtitle')}
                    </p>
                    <h1 className="text-3xl sm:text-4xl font-bold text-teal-900">
                        {t('apartmentsSection.title1')}
                    </h1>
                </div>
                <div className="flex flex-col items-center">
                    <div className="w-full max-w-md mb-6">
                        <img
                            src={apartmentRoomImage}
                            alt={t('apartmentsSection.imageAlt1')}
                            className="w-full rounded-2xl shadow-lg object-cover"
                            onError={(e) => (e.target.src = '/path/to/placeholder.jpg')}
                        />
                    </div>
                    <div className="w-full max-w-md text-center">
                        <h2 className="text-2xl sm:text-3xl font-bold mb-4">{t('apartmentsSection.aboutTitle')}</h2>
                        <h3 className="text-base sm:text-lg text-gray-600 mb-6 font-serif">
                            {t('apartmentsSection.description1')}
                        </h3>
                        <ul className="list-none text-base sm:text-lg space-y-2">
                            <li>{t('apartmentsSection.feature1')}</li>
                            <li>{t('apartmentsSection.feature2')}</li>
                            <li>{t('apartmentsSection.feature3')}</li>
                            <li>{t('apartmentsSection.feature4')}</li>
                            <li>{t('apartmentsSection.feature5')}</li>
                            <li>{t('apartmentsSection.feature6')}</li>
                        </ul>
                        <button
                            onClick={handleBookNow}
                            className="mt-6 px-6 py-3 bg-teal-900 text-white text-base sm:text-lg rounded-lg hover:bg-yellow-500 transition-colors mx-auto block"
                        >
                            {t('apartmentsSection.bookNow')}
                        </button>
                    </div>
                </div>
            </section>

            {/* Desktop Section (md and larger, ≥768px) */}
            <section className="hidden md:block container mx-auto my-8 px-4">
                <div className="text-center mb-8">
                    <p className="text-yellow-500 text-lg md:text-xl">
                        {t('apartmentsSection.subtitle')}
                    </p>
                    <h1 className="text-4xl md:text-5xl font-bold text-teal-900">{t('apartmentsSection.title1')}</h1>
                </div>
                <div className="flex flex-col md:flex-row items-center">
                    <div className="w-full md:w-1/2 mb-6 md:mb-0">
                        <img
                            src={apartmentRoomImage}
                            alt={t('apartmentsSection.imageAlt1')}
                            className="w-full rounded-2xl shadow-lg object-cover"
                            onError={(e) => (e.target.src = '/path/to/placeholder.jpg')}
                        />
                    </div>
                    <div className="w-full md:w-1/2 md:pl-6">
                        <h2 className="text-3xl md:text-4xl font-bold mb-4">{t('apartmentsSection.aboutTitle')}</h2>
                        <h3 className="text-lg md:text-xl text-gray-600 mb-6 font-serif">
                            {t('apartmentsSection.description1')}
                        </h3>
                        <ul className="list-none text-lg md:text-xl space-y-2">
                            <li>{t('apartmentsSection.feature1')}</li>
                            <li>{t('apartmentsSection.feature2')}</li>
                            <li>{t('apartmentsSection.feature3')}</li>
                            <li>{t('apartmentsSection.feature4')}</li>
                            <li>{t('apartmentsSection.feature5')}</li>
                            <li>{t('apartmentsSection.feature6')}</li>
                        </ul>
                        <button
                            onClick={handleBookNow}
                            className="mt-6 px-6 py-3 bg-teal-900 text-white text-lg md:text-xl rounded-lg hover:bg-yellow-500 transition-colors"
                        >
                            {t('apartmentsSection.bookNow')}
                        </button>
                    </div>
                </div>
            </section>
        </>
    );
};

export default ApartmentRooms;